import React from 'react';
import { useNavigate } from 'react-router-dom';

const Cancel = () => {
    const navigate = useNavigate();

    return (
        <div className="cancel-page">
            <div className="cancel-container">
                <div className="cancel-icon">❌</div>
                <h1>Pagamento cancelado</h1>
                <p>Você cancelou o processo de pagamento. Que tal tentar novamente?</p>
                <div className="cancel-actions">
                    <button onClick={() => navigate('/pricing')}>
                        Ver planos novamente
                    </button>
                    <button onClick={() => navigate('/dashboard')}>
                        Voltar ao dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Cancel;